<template>
  <div>
    <v-dialog v-model="dialogOpen" persistent max-width="600">
      <v-card>
        <div
          style="display: flex; justify-content: space-between; align-items: center"
          class="px-3 py-1"
        >
          <div>
            <h3>
              {{ $t('bbl.job_interests_title') }}
            </h3>
          </div>
          <div class="text-xs-right">
            <v-btn small flat fab @click="$emit('onCloseDialog')">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-text class="py-1">
          <template v-if="selectedJob">
            <div>
              <v-btn
                text
                flat
                style="padding: 0 4px; margin: 0; min-width: 0"
                class="grey--text"
                @click="selectedJob = null"
              >
                <em class="fas fa-chevron-left mr-1" />
                {{ $t('Back') }}
              </v-btn>
            </div>
            <div class="my-1">
              <h2>{{ selectedJob.name_th }}</h2>
            </div>

            <v-list>
              <v-list-tile
                v-for="position in selectedJob.bangkokbank_job_interests"
                :key="position.id"
                :style="{
                  border: `1px solid ${$vuetify.theme.primary}`,
                  width: '100%'
                }"
                class="intent-item pa-0 mb-2"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ position.name_th }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </template>
          <template v-else>
            <v-list>
              <v-list-tile
                v-for="job in jobList"
                :key="job.id"
                :style="{
                  border: `1px solid ${$vuetify.theme.primary}`,
                  width: '100%'
                }"
                class="intent-item pa-0 mb-3"
                @click="handleSelectedJob(job)"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ job.name_th }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    jobList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogOpen: this.value,
      selectedJob: null
    }
  },
  methods: {
    handleSelectedJob(job) {
      this.selectedJob = job
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/bblcareer/Job/PreviewJobDialog.vue